import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const ContentLoader = ({ ...props }) => {
  const loaderDisplay = props.isLoading ? 'block' : 'none';

  const loaderStyle = {
    display: loaderDisplay
  };

  return <div style={loaderStyle} className={_.get(props, 'additionalClass', 'content-loader')}>
    <div className='spinner-container'>
      <div className='site-spinner' />
    </div>
  </div>;
};

ContentLoader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  additionalClass: PropTypes.string
};

export default ContentLoader;
